<div class="row" *ngIf="recordID > 0">
    <div class="col-sm-12">
        <kendo-expansionpanel [title]="'Documents'"
                              [subtitle]="''"
                              [expanded]="true">
            <kendo-grid #documentsGrid
                        [data]="gridData"
                        [sortable]="false"
                        [pageable]="false"
                        [filterable]="false">
                <kendo-grid-column field="documentTypeID" title="Action" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div style="white-space:nowrap;">
                            <a [routerLink]="" class="text-primary" (click)="viewFile(dataItem)" *ngIf="dataItem.blobFileID > 0"><i class="fas fa-eye fa-lg p-1"></i></a>
                            <a [routerLink]="" class="text-primary" (click)="downloadFile(dataItem)" *ngIf="dataItem.blobFileID > 0"><i class="fas fa-download fa-lg p-1"></i></a>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="documentTypeName" title="Document Type"></kendo-grid-column>
                <kendo-grid-column field="isRequired" title="Required?" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" [checked]="dataItem.isRequired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="fileName" title="File"></kendo-grid-column>
                <kendo-grid-column field="fileDescription" title="Description"></kendo-grid-column>
            </kendo-grid>
        </kendo-expansionpanel>
    </div>
</div>

<document-viewer [fileName]="docViewerFileName" [fileUri]="docViewerFileUri" (onClose)="viewFile({})"></document-viewer>
